export default __webpack_public_path__ + "static/media/background_kuning_2.9bb83417.png";